import React, { forwardRef } from 'react';
import styled from 'theme/styled';
import useProfile from 'core/data/profile';
import useOrganization from 'core/data/organization';
import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase';
import Avatar from '../avatar';

export type ProfileVariant = 'light' | 'dark';

interface ProfileProps extends Omit<ButtonBaseProps, 'ref'> {
  variant?: ProfileVariant;
  onClick?: () => void;
}

function ForwardableProfile(
  { onClick, variant = 'light', ...props }: ProfileProps,
  ref: any,
): JSX.Element {
  const [profile] = useProfile();
  const [{ name }] = useOrganization();
  return (
    <ButtonBase ref={ref} disabled={!onClick} onClick={onClick} {...props}>
      <ProfileContainer>
        <div className={`profile-details ${variant}`}>
          <span className='user-name'>
            {`${profile.firstName || ''} ${profile.lastName || ''}`}
          </span>
          <span className='organization-name'>{name}</span>
        </div>

        <Avatar user={profile} />
      </ProfileContainer>
    </ButtonBase>
  );
}

const Profile = forwardRef<any, ProfileProps>(ForwardableProfile);
export default Profile;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;

  .profile-details {
    &.light {
      color: ${({ theme }) => theme.palette.common.white};
    }

    &.dark {
      color: ${({ theme }) => theme.palette.text.primary};
    }

    margin-right: ${({ theme }) => theme.spacing(1)};
    text-align: right;

    .user-name {
      display: block;
      font-weight: bold;
      letter-spacing: 0.02em;
    }
  }
`;
